import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { PteEvent } from './pte-events.component';
import { AppConstants } from 'src/app/app.constants';
import { catchError } from 'rxjs/operators';

export interface PteEventsParams {
  dropdown_type: 'today' | 'history';
  page: number;
  page_size: number;
  start_date?: string;
  end_date?: string;
  search?: string;
  user_email?: string;
  inserted_start_date?: string;
  inserted_end_date?: string;
}

export interface PteEventsResponse {
  data: PteEvent[];
  total?: number;
  total_count?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PteEventsService {

  private apiUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.PTE_EVENTS.GET_EVENTS}/`;
  private ptePdfUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.PTE_EVENTS.GET_PTE_PDF}/`;
  constructor(private http: HttpClient) { }

  /** Get PTE events with pagination. Optional start_date/end_date for filtering. */
  getPteEvents(params: PteEventsParams): Observable<PteEventsResponse> {
    let httpParams = new HttpParams()
      .set('dropdown_type', params.dropdown_type)
      .set('page', String(params.page))
      .set('page_size', String(params.page_size))
      .set('user_email', params.user_email || '');

    if (params.start_date) {
      httpParams = httpParams.set('start_date', params.start_date);
    }
    if (params.end_date) {
      httpParams = httpParams.set('end_date', params.end_date);
    }
    if (params.inserted_start_date) {
      httpParams = httpParams.set('inserted_start_date', params.inserted_start_date);
    }
    if (params.inserted_end_date) {
      httpParams = httpParams.set('inserted_end_date', params.inserted_end_date);
    }
    if (params.search) {
      httpParams = httpParams.set('search', params.search);
    }

    return this.http.get<PteEventsResponse>(this.apiUrl, { params: httpParams });
  }

  getPtePdf(params: PtePdfParams): Observable<any> {
    let httpParams = new HttpParams()
      .set('pdf_url', params.pdf_url);

    return this.http.get(this.ptePdfUrl, {
      params: httpParams,
      responseType: 'text'
    });
  }

  getDSTime(): Observable<any> {
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.LMS_DS_TIME}`
    ).pipe(
      catchError((error) => {
        console.error('Error fetching DS time:', error);
        return of(null);
      })
    );
  }
}

export interface PtePdfParams {
  pdf_url: string;
}

export interface PtePdfResponse {
  data: string;
}